"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchDrawingSchema = void 0;
const zod_1 = require("zod");
const SchematicReference_1 = require("../SchematicReference");
const Bus_1 = require("./Bus");
const Circle_1 = require("./Circle");
const Arc_1 = require("./Arc");
const Curve_1 = require("./Curve");
const Polygon_1 = require("./Polygon");
const TextBox_1 = require("./TextBox");
const DrawingGroup_1 = require("./DrawingGroup");
const Junction_1 = require("./Junction");
const Label_1 = require("./Label");
const Rect_1 = require("./Rect");
const Segment_1 = require("./Segment");
const Text_1 = require("./Text");
const Track_1 = require("./Track");
const Image_1 = require("./Image");
const RichText_1 = require("./RichText");
exports.SchDrawingSchema = zod_1.z.discriminatedUnion('type', [
    Arc_1.ArcSchema,
    Curve_1.CurveSchema,
    Bus_1.BusSchema,
    Circle_1.CircleSchema,
    Image_1.ImageSchema,
    Junction_1.JunctionSchema,
    Label_1.LabelSchema,
    Polygon_1.PolygonSchema,
    Segment_1.SegmentSchema,
    Rect_1.RectSchema,
    RichText_1.RichTextSchema,
    Text_1.TextSchema,
    Track_1.TrackSchema,
    SchematicReference_1.SchematicReferenceSchema,
    DrawingGroup_1.DrawingGroupSchema,
    TextBox_1.TextBoxSchema,
]);
//# sourceMappingURL=SchDrawing.js.map